import React from 'react';
import PropTypes from 'prop-types';

import Snooze from './Snooze';

class SuggestedSnoozeItem extends React.PureComponent {
  handleSnoozeClick = () => {
    this.props.onClick(this.props.suggestion);
  }

  render() {
    return (
      <li>
        <Snooze type="button" onClick={this.handleSnoozeClick}>
          {this.props.suggestion.name}
        </Snooze>
      </li>
    );
  }
}

SuggestedSnoozeItem.propTypes = {
  suggestion: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
};

SuggestedSnoozeItem.defaultProps = {
  onClick: () => {},
};

export default SuggestedSnoozeItem;
